import {
  faBuildingColumns,
  faCreditCard,
  faGift,
  faMoneyBill,
  faMoneyBillAlt,
  faMoneyCheck,
} from '@fortawesome/pro-regular-svg-icons';

import { PaymentMethodType } from './_types';


export const getPaymentMethodType = (type: string): string => {
  switch (type.toLowerCase()) {
    case 'card':
      return 'Credit Card';
    case 'us_bank_account':
      return 'Bank Account';
    default:
      return type;
  }
};

export const getPaymentMethodIcon = (type: string) => {
  switch (type.toLowerCase()) {
    case 'card':
      return faCreditCard;
    case 'us_bank_account':
      return faBuildingColumns;
    case 'cash':
      return faMoneyBill;
    case 'check':
      return faMoneyCheck;
    case 'free':
      return faGift;
    case 'other':
      return faMoneyBillAlt;
    default:
      return faCreditCard;
  }
};

export const getPaymentMethodsForCurrency = (
  currency: string
): PaymentMethodType[] => {
  if (currency === 'usd') {
    return ['card', 'us_bank_account'];
  } else if (currency === 'gbp') {
    return ['card'];
  } else if (currency === 'cad') {
    return ['card', 'acss_debit'];
  } else if (currency === 'eur') {
    return ['card', 'sepa_debit'];
  } else if (currency === 'aud') {
    return ['card', 'au_becs_debit'];
  }
  return ['card'];
};
